import {
  Provision,
  SettlementSchema,
} from "@redotech/redo-model/draft-return/draft-return";
import { zExt } from "@redotech/rpc/ext";
import { z } from "zod";

export const submitDraftReturn = {
  input: z.object({
    draftReturnId: zExt.objectId(),
    settlement: SettlementSchema.nullish(),
    provisionType: Provision,
    paymentToken: z.string().nullish(),
    customerTimeZone: z.string().nullish(),
  }),
  output: z.object({ returnId: z.string() }),
};
